<template>
  <van-overlay show @click="$emit('close')" z-index="1000">
    <div class="overlay-wrapper">
      <div class="text-white text-center leading-22 rounded-medium border border-dashed border-border-gray px-5 py-2">
        <div>
          <span>点击浏览器【分享】按钮</span>
        </div>
        <div>
          <span>发送给微信好友或分享到朋友圈</span>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'DefaultShareTip'
}
</script>
